import React from "react";

/**
 * Landing-page background — fixed full-screen hero image with a
 * cinematic colour grade. Premium automotive aesthetic with
 * controlled mid-tone brightness, deeper contrast, and a
 * strong vignette that draws the eye toward the centre form.
 *
 * Simplified to 3 efficient layers (down from 5) for better
 * performance while maintaining the premium feel.
 */
export const LandingBackdrop = () => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 0,
      pointerEvents: "none",
      animation: "backdrop-fade-in 1.5s ease-out forwards",
      // Solid dark base under the photo so no blank white void can ever
      // appear at any scroll position (light mode included) — even while
      // the hero JPEG is still loading or if it fails to paint.
      background: "#0b0f14",
    }}
  >
    {/* 0 — Hero photo with cinematic color grade */}
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundImage: "url('/landing-bg.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        filter: "var(--wf-bd-photo-filter)",
        zIndex: 0,
      }}
    />

    {/* 1 — Cinematic letterbox gradient + cool cast (combined) */}
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: `
          linear-gradient(180deg,
            var(--wf-bd-grad-top) 0%,
            var(--wf-bd-grad-q1) 18%,
            var(--wf-bd-grad-q2) 45%,
            var(--wf-bd-grad-q3) 55%,
            var(--wf-bd-grad-q4) 78%,
            var(--wf-bd-grad-bot) 100%
          )
        `,
        zIndex: 1,
        pointerEvents: "none",
      }}
    />

    {/* 2 — Radial vignette + subtle emerald accent orb */}
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: `
          radial-gradient(ellipse at 50% 40%,
            rgba(16, 185, 129, 0.04) 0%,
            rgba(0, 0, 0, 0) 40%,
            var(--wf-bd-vignette-mid) 75%,
            var(--wf-bd-vignette-edge) 100%
          )
        `,
        zIndex: 1,
        pointerEvents: "none",
      }}
    />

    {/* 3 — Floating gradient orb (animated via CSS) */}
    <div
      className="landing-gradient-orb"
      style={{
        position: "fixed",
        top: "20%",
        left: "50%",
        width: "min(600px, 80vw)",
        height: "min(600px, 80vw)",
        transform: "translateX(-50%)",
        background: "radial-gradient(circle, rgba(16, 185, 129, 0.06) 0%, rgba(6, 78, 59, 0.03) 40%, transparent 70%)",
        filter: "blur(60px)",
        zIndex: 1,
        pointerEvents: "none",
      }}
    />

    <style>{`
      @keyframes backdrop-fade-in {
        from { opacity: 0; }
        to { opacity: 1; }
      }
    `}</style>
  </div>
);
